// Shared ENERGY STAR property readiness + score-eligibility UI helpers.
// Used by both Settings → Energy Star (mapping) and the Energy Star Report so the
// two surfaces always show the same statuses, badges and filters.
import { CheckCircle2, PlugZap, AlertTriangle, Gauge, Ban, Info, Star } from 'lucide-react';

export const READINESS_META = {
  ready: { label: 'Ready to connect', cls: 'bg-emerald-50 text-emerald-700 border-emerald-200', dot: 'bg-emerald-500', Icon: CheckCircle2 },
  connected: { label: 'Connected', cls: 'bg-sky-50 text-sky-700 border-sky-200', dot: 'bg-sky-500', Icon: PlugZap },
  missing_details: { label: 'Missing property details', cls: 'bg-amber-50 text-amber-700 border-amber-200', dot: 'bg-amber-500', Icon: AlertTriangle },
  missing_meters: { label: 'Missing meters', cls: 'bg-amber-50 text-amber-700 border-amber-200', dot: 'bg-amber-500', Icon: Gauge },
  needs_attention: { label: 'Needs attention', cls: 'bg-rose-50 text-rose-700 border-rose-200', dot: 'bg-rose-500', Icon: AlertTriangle },
  unsupported: { label: 'Unsupported configuration', cls: 'bg-zinc-100 text-zinc-600 border-zinc-300', dot: 'bg-zinc-400', Icon: Ban },
};

export const SCORE_ELIG_META = {
  score: { label: '1–100 score eligible', cls: 'bg-emerald-50 text-emerald-700 border-emerald-200', Icon: Star,
    tip: 'This property type can earn an ENERGY STAR 1–100 score once it has 12 consecutive months of data.' },
  metrics: { label: 'Metrics only', cls: 'bg-slate-50 text-slate-600 border-slate-200', Icon: Gauge,
    tip: 'ENERGY STAR can compute Source/Site EUI and emissions for this property, but this property type does not receive a 1–100 score.' },
  none: { label: 'Eligibility pending', cls: 'bg-zinc-100 text-zinc-500 border-zinc-200', Icon: Info,
    tip: 'Add the gross floor area (and a scoreable primary function) to determine ENERGY STAR eligibility.' },
};

export const READINESS_FILTERS = [
  { key: 'ready', label: 'Ready to connect', match: (s) => s === 'ready' },
  { key: 'needs', label: 'Needs information', match: (s) => ['missing_details', 'missing_meters', 'unsupported'].includes(s) },
  { key: 'connected', label: 'Connected', match: (s) => s === 'connected' },
  { key: 'errors', label: 'Errors', match: (s) => s === 'needs_attention' },
  { key: 'all', label: 'All', match: () => true },
];

export function filterCount(counts, key) {
  const c = counts || {};
  switch (key) {
    case 'ready': return c.ready || 0;
    case 'needs': return (c.missing_details || 0) + (c.missing_meters || 0) + (c.unsupported || 0);
    case 'connected': return c.connected || 0;
    case 'errors': return c.needs_attention || 0;
    case 'all': return Object.values(c).reduce((a, b) => a + (b || 0), 0);
    default: return 0;
  }
}

export const matchFilter = (key, status) =>
  (READINESS_FILTERS.find((f) => f.key === key) || READINESS_FILTERS[4]).match(status);
